import { formatNumber } from '@utils/formatNumber'
import { routes } from '@routes/index'
import * as React from 'react'
import { Link } from 'gatsby'

export type ValidationMessagesProps = {
  [key in keyof typeof validationMessages]: string | object
}

const validationMessages = {
  signatureRequired: 'Uw handtekening is verplicht.',
  signatureTooSmall: 'Uw handtekening is te klein.',
  firstName: 'Vul een voornaam in.',
  phoneNumber: 'Vul een telefoonnummer in.',
  reference: 'Vul een referentie in.',
  mobileNumber: 'Vul een mobiel telefoonnummer in.',
  question: 'Vul hier uw vraag in.',
  company: 'Vul hier uw bedrijfsnaam in.',
  fax: 'Vul hier uw fax nummer in.',
  email: 'Please fill in a valid email address.',
  attachment_size: 'Het bestand mag maximaal 10 MB zijn.',
  attachment_extension: `Het gekozen bestand kan niet geüpload worden. Alleen bestanden met de volgende extensies zijn toegestaan: jpg, jpeg, png, pdf`,
  conditions: 'U dient akkoord te gaan met de voorwaarden.',
  required: 'Dit veld is verplicht',
  validHouseNumber: 'Vul een geldig huisnummer in',
  validNumber: 'Vul een geldig aantal in',
  addressSearchRequired: 'Zoek en selecteer uw woning',
  emailInvalid: 'Vul een geldig emailadres in.',
  maxChars: (max: number) => `Vul maximaal ${max} tekens in.`,
  minChars: (min: number) => `Vul minimaal ${min} tekens in.`,
  equalToPassword: 'Wachtwoorden komen niet overeen.',
  equalToEmail: 'E-mailadressen komen niet overeen.',
  exactChars: (minMax: number) => `Vul ${minMax} tekens in.`,
  digitsOnly: 'Dit veld mag alleen cijfers bevatten.',
  defaultOption: 'Please select an option.',
  terms: 'You have to agree to our terms and conditions.',
  salutationRequired: 'Selecteer een aanhef.',
  maxDate: 'Please select a date from the past.',
  requiredNumber: 'Vul een bedrag in.',
  minNumber: (min: number) => `Vul een waarde in van minimaal ${formatNumber(min)}.`,
  maxNumber: (max: number) => `Vul een waarde in van maximaal ${formatNumber(max)}.`,
  validYear: () => `Vul een geldig jaartal in.`,
  invalidCredentials: 'Wachtwoord onjuist, probeer nog eens of wachtwoord vergeten?',
  oldPasswordIncorrect: 'Het opgegeven huidige wachtwoord is incorrect, probeer opnieuw.',
  notFoundOrExpired:
    'Het verzoek om uw wachtwoord te wijzigen is verlopen. U kunt een nieuw verzoek aanvragen via wachtwoord vergeten.',
  accountAlreadyExists: (
    <>
      Er bestaat al een account voor het opgegeven e-mailadres.{' '}
      <strong>
        <u>
          <Link to={routes.signIn}>Log in</Link>
        </u>
      </strong>{' '}
      om verder te gaan.
    </>
  ),
  accountAlreadyExistsV2: 'Er bestaat al een account voor het opgegeven e-mailadres.',
  defaultError: 'Er is een fout opgetreden, probeer het opnieuw.',
  phoneError: 'Uw 10-cijferige telefoonnummer is vereist.',
  fileTypeInvalid: 'Het gekozen bestandstype is niet correct.',
  fileToolarge: 'Het bestand is te groot.',
}

export default validationMessages
